import { QReportsMetaData } from "./QReportsMetaData";
import { QReport } from "./QReport";
import { QAnnualReport } from "./QAnnualReport";
export const QueryBuilder = {
    reportsMetaData: QReportsMetaData,
    report: QReport,
    annualReport: QAnnualReport
};
//# sourceMappingURL=index.js.map